var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_vm._l((_vm.stylesheets),function(sheet){return _c('link',{key:sheet,attrs:{"rel":"stylesheet","href":sheet}})}),(_vm.loaded)?_vm._t("default"):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }